import {Component} from '@angular/core';
import {MtxGrid, MtxGridColumn} from "@ng-matero/extensions/grid";
import {BaseTableComponent} from "../../../../core/BaseTableComponent";
import {ProductResponse} from "../../../../model/product/ProductResponse";
import {ProductSearchResponse} from "../../../../model/product/ProductSearchResponse";
import {ProductService} from "../../../../services/product/ProductService";
import {ProductSearchService} from "../../../../services/product/ProductSearchService";
import {SearchHistoryResponse} from "../../../../model/product/SearchHistoryResponse";
import {BasePageResponse} from "../../../../core/BaseResponse";
import {UserResponse} from "../../../../model/user/UserResponse";

@Component({
  selector: 'app-product-search-history',
  standalone: true,
  imports: [
    MtxGrid
  ],
  templateUrl: './product-search-history.component.html',
  styleUrl: './product-search-history.component.css',
  providers: [ProductSearchService]
})
export class ProductSearchHistoryComponent extends BaseTableComponent<SearchHistoryResponse> {

  constructor(private productSearchService: ProductSearchService) {
    super()
  }

  load(): void {
    this.paging<BasePageResponse<Array<SearchHistoryResponse>>>(
      this.productSearchService.searchHistory(this.pageIndex, this.pageSize, this.searchQuery),
      (data) => {
        return data.data
      },
      (data) => {
        return data.totalElements
      }
    )
  }

  columns: MtxGridColumn[] = [
    {
      header: "Поиск",
      field: 'search',
      sortable: false
    },
    {
      header: "Кол-во",
      field: 'count',
      sortable: false
    },
  ]
}
